import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';

import { CartService } from './../cart/cart.service';
import { EventService } from './../shared/event.service';

@Component({
  selector: 'app-clear-history',
  templateUrl: './clear-history.component.html',
  styleUrls: ['./clear-history.component.less']
})
export class ClearHistoryComponent {

  constructor(private bsModalRef: BsModalRef,
              private cartService: CartService,
              private eventService: EventService
  ) { }

  clearHistory(): void {
    this.eventService.clearHistory();
    this.cartService.empty();
    this.hideModal();
  }

  hideModal() {
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/clear-history/clear-history.component.ts